module.exports = __webpack_public_path__ + "img/img42.2c8cc7d2.png";